module.exports = __webpack_public_path__ + "static/media/big-logo.46dfe8b2.png";